import { render, staticRenderFns } from "./popup-fk.vue?vue&type=template&id=0681d3aa&scoped=true"
import script from "./popup-fk.vue?vue&type=script&lang=js"
export * from "./popup-fk.vue?vue&type=script&lang=js"
import style0 from "./popup-fk.vue?vue&type=style&index=0&id=0681d3aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0681d3aa",
  null
  
)

export default component.exports